import { dataFontSize } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFontSize = /*#__PURE__*/createIcon(dataFontSize)
export default IconFontSize
